import { Link } from "react-router-dom";

const CATEGORY_LINKS = [
  { label: "最新影视", to: "/category" },
  { label: "电影", to: "/category?type=电影" },
  { label: "电视剧", to: "/category?type=电视剧" },
  { label: "网剧", to: "/category?type=网剧" },
];

const ABOUT_LINKS = [
  { label: "关于我们", to: "/about" },
  { label: "网站定位", to: "/about#position" },
  { label: "联系与反馈", to: "/about#contact" },
  { label: "版权声明", to: "/about#copyright" },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-primary-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="flex items-center justify-center w-9 h-9 rounded-md bg-accent-500 text-background-50">
                <i className="ri-moon-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-white">隔壁的女孩</span>
            </div>
            <p className="text-sm leading-relaxed text-primary-200 max-w-md">
              聚焦最新影视剧资讯、剧情深度介绍与演员资料，帮助你更轻松地了解每一部好剧背后的故事。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-weibo-fill", "ri-wechat-fill", "ri-bilibili-fill", "ri-play-circle-fill"].map((icon) => (
                <span
                  key={icon}
                  className="flex items-center justify-center w-9 h-9 rounded-md bg-primary-900 text-primary-100"
                >
                  <i className={`${icon} text-base`}></i>
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-white mb-4">
              <a href="#category">影视导航</a>
            </h4>
            <ul className="space-y-2.5">
              {CATEGORY_LINKS.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-sm text-primary-200 hover:text-accent-400 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-white mb-4">
              <a href="#about">关于与帮助</a>
            </h4>
            <ul className="space-y-2.5">
              {ABOUT_LINKS.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-sm text-primary-200 hover:text-accent-400 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <p className="mt-5 text-sm text-primary-200">
              联系邮箱：
              <a href="mailto:hello@gebi-girl.com" className="text-accent-400 hover:text-accent-300">
                hello@gebi-girl.com
              </a>
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-900 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-primary-300">
          <p>© 2024 隔壁的女孩 · 本站内容均为演示数据，仅用于展示与学习。</p>
          <p>用心记录每一部值得追的好剧</p>
        </div>
      </div>
    </footer>
  );
}